import { Warning } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { errorMessage } from '@/lib/api';

export function ErrorPanel({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div role="alert" className="flex max-w-xl flex-col items-start gap-3 rounded-panel border bg-card p-5">
      <span className="flex items-center gap-2 font-display text-base font-semibold">
        <Warning className="size-5 text-destructive" weight="duotone" aria-hidden />
        Não foi possível carregar
      </span>
      <p className="text-sm text-muted-foreground">{errorMessage(error)}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Tentar de novo
        </Button>
      )}
    </div>
  );
}

export function ListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-3" role="status" aria-label="Carregando">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-14" />
      ))}
    </div>
  );
}

/** Mensagem geral de erro de formulário. */
export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="mb-4 rounded-control bg-destructive-soft px-3 py-2.5 text-sm text-destructive">
      {message}
    </p>
  );
}
